module.exports = __webpack_public_path__ + "img/google-logo.36c3f006.webp";